module.exports = __webpack_public_path__ + "media/images/cms/img_slide_07-bfd3d8ffb5b28f41f7dfb2dcdd20b974.jpg";